import { getAudioNodeRenderer } from './get-audio-node-renderer';
import { getAudioParamConnections } from './get-audio-param-connections';
export const renderInputsOfAudioParam = (context, audioParam, nativeOfflineAudioContext, nativeAudioParam) => {
    const audioParamConnections = getAudioParamConnections(context, audioParam);
    return Promise
        .all(Array
        .from(audioParamConnections.activeInputs)
        .map(([source, output]) => {
        return getAudioNodeRenderer(source)
            .render(source, nativeOfflineAudioContext)
            .then((node) => node.connect(nativeAudioParam, output));
    }));
};
//# sourceMappingURL=/build/es2018/helpers/render-inputs-of-audio-param.js.map